import { render, staticRenderFns } from "./ModalDetalhesRondas.vue?vue&type=template&id=6d37c1f8&scoped=true"
import script from "./ModalDetalhesRondas.vue?vue&type=script&lang=js"
export * from "./ModalDetalhesRondas.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalhesRondas.vue?vue&type=style&index=0&id=6d37c1f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d37c1f8",
  null
  
)

export default component.exports